import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-DETAILS-SOUSCRIPTIONS-------------------------------------------------*/
export const getDetailsSouscriptionsAction = (payload) => {
  return {
    type: ActionsTypes.GET_DETAILS_SOUSCRIPTIONS,
    payload,
  };
};

export const getDetailsSouscriptionsSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_DETAILS_SOUSCRIPTIONS_SUCCESS,
    payload,
  };
};

export const getDetailsSouscriptionsFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_DETAILS_SOUSCRIPTIONS_FAIL,
    payload,
  };
};
